export type Berechnungsart = 'offen' | 'status';

export interface FilterValues {
    sortColumn: string;
    sortDirection: 'asc' | 'desc';
    betreuer?: number;
    telBetreuer?: number;
    status?: number;
    berechnungsart: Berechnungsart;
}

export const defaultFilterValues: FilterValues = {
    sortColumn: 'auNr',
    sortDirection: 'desc',
    betreuer: undefined,
    telBetreuer: undefined,
    status: undefined,
    berechnungsart: 'status',
};

export interface LineData {
    auNr: string;
    status: number;
    datum: string;
    datBis: string;
    kNr: number;
    text: string;
    count: number;
    ekNettoGesamt: number;
    ekNettoOffen: number;
    ekNettoOffenP: number;
    vkNettoGesamt: number;
    vkNettoOffen: number;
    vkNettoOffenP: number;
    bMargeGesamt: number;
    bMargeOffen: number;
    bMargeOffenP: number;
    anzahlLieferungen: number;
    letzteLieferung: string;
}

export const defaultLineData: LineData = {
    auNr: '',
    status: 0,
    datum: '',
    datBis: '',
    kNr: 0,
    text: '',
    count: 0,
    ekNettoGesamt: 0,
    ekNettoOffen: 0,
    ekNettoOffenP: 0,
    vkNettoGesamt: 0,
    vkNettoOffen: 0,
    vkNettoOffenP: 0,
    bMargeGesamt: 0,
    bMargeOffen: 0,
    bMargeOffenP: 0,
    anzahlLieferungen: 0,
    letzteLieferung: '',
};

export interface OffeneAuftraegeSummary {
    loading: boolean;
    total: LineData;
    lineDataList: LineData[];
    betreuerTotal: { [key: string]: LineData };
    telBetreuerTotal: { [key: string]: LineData };
}
